/**
 * Navigation constants — typed views, sections, and navigation items.
 * Replaces inline magic strings in App.jsx.
 */

export const VIEWS = Object.freeze({
  MES: "mes",
  ANUAL: "anual",
  METAS: "metas",
  CONFIG: "config",
  TERMINOS: "terminos",
  PRIVACIDAD: "privacidad",
});

export const SECTIONS = Object.freeze({
  RESUMEN: "resumen",
  EDITAR: "editar",
  ANALISIS: "analisis",
  COMPARATIVA: "comparativa",
  PROYECCION: "proyeccion",
  HERRAMIENTAS: "herramientas",
  MOVIMIENTOS: "movimientos",
});

export const NAV_ITEMS = [
  { id: VIEWS.MES, icon: "📅", label: "Mes" },
  { id: VIEWS.ANUAL, icon: "📊", label: "Anual" },
  { id: VIEWS.METAS, icon: "🎯", label: "Metas" },
  { id: VIEWS.CONFIG, icon: "⚙️", label: "Config" },
];

export const SECTION_TABS = [
  { id: SECTIONS.RESUMEN, icon: "📊", label: "Resumen" },
  { id: SECTIONS.EDITAR, icon: "✏️", label: "Editar" },
  { id: SECTIONS.ANALISIS, icon: "📈", label: "Análisis" },
  // Comparativa: omitida temporalmente
  // Proyección: flujo no definido aún — oculto
  // Herramientas (presupuestos/recurrentes) movidos a Config
];

export const DEFAULT_VIEW = VIEWS.MES;
export const DEFAULT_SECTION = SECTIONS.RESUMEN;

export const isValidView = (v) => Object.values(VIEWS).includes(v);
export const isValidSection = (s) => Object.values(SECTIONS).includes(s);
